import './App.css';
import React from 'react';
import Header from './components/Header';
import Main from './Main';
import entprestigious from './subpages/entprestigious';
import {Route, Switch} from 'react-router-dom';
import ax20 from './subpages/ax20';
import Error from './subpages/Error';

function App() {
  return (
      <div className = 'app'>
        <Header />
        <Switch>
          <Route path = '/' component = {Main} exact />
          <Route path = '/user/ELITENOTORIOUSTHEPRESTIGIOUS' component = {entprestigious} />
          <Route path = '/user/ENTPRESTIGIOUS' component = {entprestigious} />
          <Route path = '/user/ax20' component = {ax20} />
          <Route component = {Error} />
        </Switch>
      </div>
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Oof
    //     </a>
    //   </header>
    // </div>
  );
}

export default App;
